import API from './api.svelte.js';

// store Promise to avoid multiple simultaneous API calls
let workspacePromise;

export function search(config = {}) {

    workspacePromise = API.search('workspace', config)
        .catch(e => {
            return Promise.resolve([]);
        })
    ;
    return workspacePromise;
}

export function create(token, config = {}){
    const url = API.url + '/signup/approve/';
    const method = 'POST';

    let data = {token: token}

    let defaults = {
        method  : method,
        headers : {
            'Content-Type' : "application/json",

        },
        body : JSON.stringify(data),
    };

    config = {...defaults, ...config};

    return fetch(url, config)
        .catch(e => {
            notificate('network_error');
            throw new Error(e);
        })
    ;
}

export function deny(token, config = {}){
    const url = API.url + '/signup/deny/';
    const method = 'POST';

    let data = {token: token}

    let defaults = {
        method  : method,
        headers : {
            'Content-Type' : "application/json",

        },
        body : JSON.stringify(data),
    };

    config = {...defaults, ...config};

    return fetch(url, config)
        .catch(e => {
            notificate('network_error');
            throw new Error(e);
        })
    ;
}

export function validateEmail(token, config = {}){
    const url = `${API.url}/signup/validate/`;
    const method = 'POST';

    let data = {token: token}

    let defaults = {
        method  : method,
        headers : {
            'Content-Type' : "application/json",

        },
        body : JSON.stringify(data),
    };

    config = {...defaults, ...config};

    return fetch(url, config)
        .catch(e => {
            notificate('network_error');
            throw new Error(e);
        })
    ;
}

export function upgradePlan(plan){
    return API.save('workspace/plan-change-solicit', {"plan": plan})
        .then(async (response) => {
            if (!response.ok) {
                let errors = await response.json();

                let toastConfig = {
                    data: "",
                    options : {
                        "timeOut": "0",
                        "extendedTimeOut": "0",
                        "showDuration": "0",
                        "hideDuration": "0",
                        "closeButton": true
                    }
                }
                notificate('save_error', "toast", toastConfig);
                throw errors;
            }
            else {
                return true;
            }
        })
        .then(apiData => {
            //returns saved element to update table
            return true;
        })
    ;
}

export function pentestSolicit(){
    return API.save('workspace/pentest-solicit')
        .then(async (response) => {
            if (!response.ok) {
                let errors = await response.json();

                let toastConfig = {
                    data: "",
                    options : {
                        "timeOut": "0",
                        "extendedTimeOut": "0",
                        "showDuration": "0",
                        "hideDuration": "0",
                        "closeButton": true
                    }
                }
                notificate('save_error', "toast", toastConfig);
                throw errors;
            }
            else {
                return true;
            }
        })
        .then(apiData => {
            //returns saved element to update table
            return true;
        })
    ;
}


export function phishingSolicit(level){
    return API.save('workspace/phishing-simulation-solicit', {"level": level})
        .then(async (response) => {
            if (!response.ok) {
                let errors = await response.json();

                let toastConfig = {
                    data: "",
                    options : {
                        "timeOut": "0",
                        "extendedTimeOut": "0",
                        "showDuration": "0",
                        "hideDuration": "0",
                        "closeButton": true
                    }
                }
                notificate('save_error', "toast", toastConfig);
                throw errors;
            }
            else {
                return true;
            }
        })
        .then(apiData => {
            //returns saved element to update table
            return true;
        })
    ;
}


export default {
    search,
    create,
    deny,
    validateEmail,
    upgradePlan,
    pentestSolicit,
    phishingSolicit
}
